export default __webpack_public_path__ + "static/media/work_learn.crown_icon.2f7629b5.svg";